var _g, _g2, _g3, _g4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    xmlns: "http://www.w3.org/2000/svg",
    height: 26,
    id: "screenshot-fe1009f2-7351-805c-8007-3334975e0048",
    viewBox: "896 1710 26 26",
    style: {
      WebkitPrintColorAdjust: ":exact"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "shape-fe1009f2-7351-805c-8007-3334975e0048"
  }, /*#__PURE__*/React.createElement("g", {
    className: "frame-container-wrapper"
  }, /*#__PURE__*/React.createElement("g", {
    className: "frame-container-blur"
  }, /*#__PURE__*/React.createElement("g", {
    className: "frame-container-shadows"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-fe1009f2-7351-805c-8007-3334975e0048"
  }, /*#__PURE__*/React.createElement("rect", {
    rx: 0,
    ry: 0,
    x: 896,
    y: 1710,
    width: 26,
    height: 26,
    transform: "matrix(1.000000, 0.000000, 0.000000, 1.000000, 0.000000, 0.000000)",
    className: "frame-background"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "frame-children"
  }, /*#__PURE__*/React.createElement("g", {
    id: "shape-fe1009f2-7351-805c-8007-333495cc9754",
    rx: 0,
    ry: 0
  }, /*#__PURE__*/React.createElement("g", {
    id: "shape-fe1009f2-7351-805c-8007-3332094a9c79",
    style: {
      fill: "#000000"
    },
    rx: 0,
    ry: 0
  }, /*#__PURE__*/React.createElement("g", {
    id: "shape-fe1009f2-7351-805c-8007-3332094ae230",
    style: {
      display: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-fe1009f2-7351-805c-8007-3332094ae230"
  }, /*#__PURE__*/React.createElement("rect", {
    rx: 0,
    ry: 0,
    x: 896,
    y: 1710,
    transform: "matrix(1.000000, 0.000000, 0.000000, 1.000000, 0.000000, 0.000000)",
    width: 26,
    height: 26,
    fill: "none",
    style: {
      fill: "none"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "shape-fe1009f2-7351-805c-8007-3332094ae231"
  }, /*#__PURE__*/React.createElement("defs", {
    style: {
      fill: "#000000"
    }
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "shape-fe1009f2-7351-805c-8007-3332094ae232"
  }, /*#__PURE__*/React.createElement("style", null, "\r\n                          #shape-fe1009f2-7351-805c-8007-3332094a9c79 {\r\n                            .cls-1 {\r\n                              fill: none;\r\n                              stroke: #ff9000;\r\n                              stroke-miterlimit: 10;\r\n                            }\r\n\r\n                            .cls-2 {\r\n                              fill: #ff9000;\r\n                              stroke-width: 0px;\r\n                            }\r\n                          }\r\n                        "))))), /*#__PURE__*/React.createElement("g", {
    id: "shape-fe1009f2-7351-805c-8007-3332094ae234",
    style: {
      fill: "#000000"
    },
    rx: 0,
    ry: 0
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "shape-fe1009f2-7351-805c-8007-3332094ae235"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-fe1009f2-7351-805c-8007-3332094ae235"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M911.3800048828125,1718.27001953125L909,1716.06005859375L902.1799926757812,1722.3900146484375C902.0800170898438,1722.47998046875,902.0800170898438,1722.6300048828125,902.1699829101562,1722.72998046875C902.260009765625,1722.8299560546875,902.4100341796875,1722.8299560546875,902.510009765625,1722.739990234375L903.2999877929688,1722.010009765625L903.2999877929688,1729.93994140625L914.719970703125,1729.93994140625L914.719970703125,1722.010009765625L915.510009765625,1722.739990234375C915.510009765625,1722.739990234375,915.6099853515625,1722.800048828125,915.6700439453125,1722.800048828125C915.72998046875,1722.800048828125,915.7999877929688,1722.77001953125,915.8399658203125,1722.719970703125C915.9299926757812,1722.6199951171875,915.9200439453125,1722.469970703125,915.8299560546875,1722.3800048828125L915.8299560546875,1722.3800048828125L913.760009765625,1720.4599609375L911.3800048828125,1718.25ZM913.280029296875,1720.030029296875L911.8499755859375,1718.699951171875",
    className: "cls-2"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "shape-fe1009f2-7351-805c-8007-3332094b2384"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-fe1009f2-7351-805c-8007-3332094b2384"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 909,
    cy: 1723,
    rx: 12.5,
    ry: 12.5,
    transform: "matrix(1.000000, 0.000000, 0.000000, 1.000000, 0.000000, 0.000000)",
    className: "cls-1"
  }))))))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.c9e8fb9404e1432e09bcb0418062f3f3.svg";
export { ForwardRef as ReactComponent };